import { environment } from "src/environments/environment";
import { FCMMessageRegistration } from "./FCMMessageRegistration";
import { AppConfigService } from "src/app/Service/Configuration/app-config.service";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class APIFactoryEndPoints {

    readonly getServerUrl: string;

    readonly saveUsersaveTokenIdLocId: string;
    readonly getRiderByEmail: string;
    readonly insertRider: string;
    readonly updateActiveStatus: string;

    readonly getDeliveryDetailsByEmployeeIdAndDate: string;
    readonly getShippingSequenceData: string;

    readonly insertShipping: string;
    readonly deleteShippingSequenceData: string;
    readonly getTrafficDetails: string;
    readonly insertServiceManCurrentLocation: string;
    readonly getReasonOfPickupCancellation: string;
    readonly getReasonOfCancellation: string;
    readonly getReasonOfRescheduling: string;
    readonly getDeliveryDetailsByInvNo: string;
    readonly insertReceiptVoucher: string;
    readonly uploadImgForShipping: string;
    readonly getUpiBankSetupByLoc: string;
    readonly getCardBankSetupByLoc: string;
    readonly getBankBankSetupByLoc: string;
    readonly getPaytmBankSetupByLoc: string;
    readonly getCouponAmount: string;
    readonly collectPayByVpa: string;
    readonly fetchUpiPaymentDetails: string;
    readonly getQrForUpi: string
    readonly sendSmsForUpi: string;
    readonly initiateNotification: string;
    readonly getQrForPaytm: string;
    readonly collectPayByVpaPaytm: string;
    readonly fetchPaytmPaymentDetails: string;
    readonly getWalletTransactionByEmail: string;
    readonly getCheckedOutWalletOffers: string;
    readonly sendPaymentRequestToEDC: string;
    readonly checkPayTmPaymentStatus: string;
    readonly insertPaytmResponse: string;
    readonly getGatewayPaymentSetup: string;
    readonly sendGatewayPaymentRequest: string;
    readonly sendWhatsAppMessageToRecipient: string;
    readonly getCustomerInitialData: string;
    readonly getStatesbyCountryCode: string;
    readonly getDistrictsbyStateCodeWithAll: string;
    readonly getCityByDistrict: string;
    readonly getCustomerCustomerWithLocationBymobAndName: string;
    readonly getCustomerByCustomerCode: string;
    readonly insertCustomerFromOtherModules: string;
    readonly sendWhatsAppOptInByMobileNo: string;
    readonly sendWhatsAppOTPByMobileNo: string;
    readonly getLocationById: string;
    readonly getOptmizedMapDetailsWithTrafficAndWeather: string;
    readonly insertShippingSequenceData: string;
    readonly saveRouteDetailsAsPerMap: string;
    readonly insertShippingFeedBack: string;
    readonly getShippingFeedBack: string;
    readonly acceptOrderByOrderNo: string;
    readonly deliveryFareDetails: string;


    readonly getTripFareSummaryByRiderOnDate: string;
    readonly getRiderRatingByEmail: string;
    readonly getShippingDateSummaryByRiderOnDate: string;
    readonly getTripNoByRiderOnDate: string;
    readonly getDeliveryFareDetailsByRiderEmailIdAndDateRange: string;
    readonly insertRaiseDispute: string;
    readonly getRiderAccountDataByEmail: string;

    readonly getFileServerOldUrl: string;

    readonly updateRiderPositionByEmailId: string;

    readonly sendMessageByMailChimp: string;

    readonly signOutRider: string;


    constructor(private appConfig: AppConfigService) {

        this.getServerUrl = this.appConfig.setting.riderApiUrl;

        this.saveUsersaveTokenIdLocId = this.appConfig.setting.oldApiUrl + "common/User/saveTokenIdLocId";
        this.getRiderByEmail = this.appConfig.setting.oldApiUrl + "order/web-order/getRiderDetailsByEmail";
        this.insertRider = this.appConfig.setting.riderApiUrl + "rider/insert";
        this.updateActiveStatus = this.appConfig.setting.oldApiUrl + "update-rider-active-status";

        this.getDeliveryDetailsByEmployeeIdAndDate = this.appConfig.setting.oldApiUrl + 'order/shipping-management/getDeliveryDetailsByRiderIdAndDate';
        this.getShippingSequenceData = this.appConfig.setting.oldApiUrl + 'order/shipping-management/getShippingSequenceData';

        this.insertShipping = this.appConfig.setting.oldApiUrl + "order/shipping-management/insert-assign-shipping";
        this.deleteShippingSequenceData = this.appConfig.setting.oldApiUrl + 'order/shipping-management/deleteShippingSequenceData';
        this.getTrafficDetails = this.appConfig.setting.oldApiUrl + "crm/tools/route-optimiser/getTrafficDetails";
        this.insertServiceManCurrentLocation = this.appConfig.setting.oldApiUrl + 'order/shipping-management/insertServiceManCurrentLocation';
        this.getReasonOfPickupCancellation = this.appConfig.setting.oldApiUrl + 'order/shipping-management/getReasonOfPickupCancellation';
        this.getReasonOfCancellation = this.appConfig.setting.oldApiUrl + 'order/shipping-management/getReasonOfCancellation';
        this.getReasonOfRescheduling = this.appConfig.setting.oldApiUrl + 'order/shipping-management/getReasonOfRescheduling';
        this.getDeliveryDetailsByInvNo = this.appConfig.setting.oldApiUrl + 'order/shipping-management/getDeliveryDetailsByInvoiceNo';
        this.insertReceiptVoucher = this.appConfig.setting.oldApiUrl + 'accounts/vouchers/insertForShipping';
        this.uploadImgForShipping = this.appConfig.setting.riderApiUrl + 'shipping-management/uploadFile-before';
        this.getUpiBankSetupByLoc = this.appConfig.setting.oldApiUrl + "common/admin/transaction-setup/upiBankSetupByLoc";
        this.getCardBankSetupByLoc = this.appConfig.setting.oldApiUrl + "common/admin/transaction-setup/cardBankSetupByLoc";
        this.getBankBankSetupByLoc = this.appConfig.setting.oldApiUrl + "common/admin/transaction-setup/bankBankSetupByLoc";
        this.getPaytmBankSetupByLoc = this.appConfig.setting.riderApiUrl + "getByLocation";
        this.getCouponAmount = this.appConfig.setting.oldApiUrl + "admin/master/view/coupon/getValidCouponsbyCode/";
        this.collectPayByVpa = this.appConfig.setting.oldApiUrl + "common/collect-pay-by-vpa";
        this.fetchUpiPaymentDetails = this.appConfig.setting.oldApiUrl + "common/get-upi-transaction-status";
        this.getQrForUpi = this.appConfig.setting.oldApiUrl + "common/get-qr-string";
        this.sendSmsForUpi = this.appConfig.setting.oldApiUrl + "common/send-sms-intent";
        this.initiateNotification = this.appConfig.setting.integrationUrl + "notification/";
        this.getQrForPaytm = this.appConfig.setting.oldApiUrl + "paytm/generatePayTmQRCode";
        this.collectPayByVpaPaytm = this.appConfig.setting.oldApiUrl + "paytm/sendPaymentRequestLink";
        this.fetchPaytmPaymentDetails = this.appConfig.setting.oldApiUrl + "paytm/sendPaymentRequestLink";
        this.getWalletTransactionByEmail = this.appConfig.setting.oldApiUrl + "common/get-all-wallet-transaction-by-user-email";
        this.getCheckedOutWalletOffers = this.appConfig.setting.oldApiUrl + "common/wallet/get-checked-out-wallet-offers";
        this.sendPaymentRequestToEDC = this.appConfig.setting.oldApiUrl + "paytm/sendPaymentRequestToEDC";
        this.checkPayTmPaymentStatus = this.appConfig.setting.oldApiUrl + "paytm/checkPayTmPaymentStatus";
        this.insertPaytmResponse = this.appConfig.setting.oldApiUrl + "common/insert-paytm-response";
        this.getGatewayPaymentSetup = this.appConfig.setting.oldApiUrl + "common/admin/transaction-setup/gatewayPaymentSetupByCompanyAndProvider";
        this.sendGatewayPaymentRequest = this.appConfig.setting.integrationUrl + "api/v1/encryptAnyDataMob";
        this.sendWhatsAppMessageToRecipient = this.appConfig.setting.riderApiUrl + "messaging/sendWhatsAppMessageByMobileNo"
        this.getCustomerInitialData = this.appConfig.setting.oldApiUrl + "admin/master/view/customer/getinitialdata";
        this.getStatesbyCountryCode = this.appConfig.setting.oldApiUrl + "admin/master/view/state/getStatesbyCountryCode";
        this.getDistrictsbyStateCodeWithAll = this.appConfig.setting.oldApiUrl + "admin/master/view/district/getDistrictsbyStateCodeWithAll";
        this.getCityByDistrict = this.appConfig.setting.oldApiUrl + "admin/master/view/city/getCitiesbyDistrictCode";
        this.getCustomerCustomerWithLocationBymobAndName = this.appConfig.setting.oldApiUrl + "admin/master/view/customer/getcustomerswithlocation"
        this.getCustomerByCustomerCode = this.appConfig.setting.oldApiUrl + "admin/master/view/customer/customerByCode"
        this.insertCustomerFromOtherModules = this.appConfig.setting.oldApiUrl + "admin/master/customer/insertFromOtherModules";
        this.sendWhatsAppOptInByMobileNo = this.appConfig.setting.oldApiUrl + "common/integration/sendWhatsAppOptInByMobileNo";
        this.sendWhatsAppOTPByMobileNo = this.appConfig.setting.oldApiUrl + "common/integration/sendWhatsAppOTPByMobileNo";
        this.getLocationById = this.appConfig.setting.oldApiUrl + "admin/master/view/location/getLocationById";
        this.getOptmizedMapDetailsWithTrafficAndWeather = this.appConfig.setting.oldApiUrl + "crm/tools/route-optimiser/getOptmizedMapDetailsWithTrafficAndWeather";
        this.insertShippingSequenceData = this.appConfig.setting.oldApiUrl + 'order/shipping-management/insertShippingSequenceData';
        this.saveRouteDetailsAsPerMap = this.appConfig.setting.oldApiUrl + 'order/shipping-management/saveRouteDetailsAsPerMap';
        this.insertShippingFeedBack = this.appConfig.setting.oldApiUrl + 'common/saveFeedBack';
        this.getShippingFeedBack = this.appConfig.setting.oldApiUrl + 'common/getFeedBackByAssignedRefNo';
        this.acceptOrderByOrderNo = this.appConfig.setting.oldApiUrl + 'order/shipping-management/accept-delivery';
        this.deliveryFareDetails = this.appConfig.setting.oldApiUrl + 'order/shipping-management/getDeliveryFareDetailsByRiderAndDateRange';


        this.getTripFareSummaryByRiderOnDate = this.appConfig.setting.oldApiUrl + 'order/shipping-management/getTripFareSummaryByRiderOnDate';
        this.getRiderRatingByEmail = this.appConfig.setting.oldApiUrl + 'order/shipping-management/getRiderRatingByEmail';
        this.getShippingDateSummaryByRiderOnDate = this.appConfig.setting.riderApiUrl + 'getShippingDateSummaryByRiderOnDate';
        this.getTripNoByRiderOnDate = this.appConfig.setting.oldApiUrl + 'order/shipping-management/getTripNosAndShippingNoByRiderAndDate';
        this.getDeliveryFareDetailsByRiderEmailIdAndDateRange = this.appConfig.setting.oldApiUrl + 'order/shipping-management/getDeliveryDetailsByRiderEmailIdAndDateRange';
        this.insertRaiseDispute = this.appConfig.setting.oldApiUrl + "order/shipping-management/raiseDisputeByEmpIdShippingNo";
        this.getRiderAccountDataByEmail = this.appConfig.setting.oldApiUrl + 'order/shipping-management/getRiderAccountDataByEmail';

        this.getFileServerOldUrl = this.appConfig.setting.oldApiUrl + 'common/get-files-by-folder-and-name';

        this.updateRiderPositionByEmailId = this.appConfig.setting.oldApiUrl + "rider/updateRiderPositionByEmailId";

        this.sendMessageByMailChimp = this.appConfig.setting.riderApiUrl + "send-message-by-mailchimp";

        this.signOutRider = "https://authlogin.mobitrix.net/googleSignOut";
    }
}
